import { render, staticRenderFns } from "./LinkedAccounts.vue?vue&type=template&id=31c51c06"
import script from "./LinkedAccounts.vue?vue&type=script&lang=js"
export * from "./LinkedAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports